import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { BUSINESS_POLICY_BASIC_DETAILS } from "../Business.constants";



const BusinessPolicyBasicDetails = Loadable(
  lazy(() =>
	import("./BusinessPolicyBasicDetails").then(
	  ({ BusinessPolicyBasicDetails }) => ({
		default: BusinessPolicyBasicDetails,
	  })
	)
  )
);

const BusinessPolicyContacts = Loadable(
  lazy(() =>
    import("../BusinessPolicyContacts/BusinessPolicyContacts").then(
      ({ BusinessPolicyContacts }) => ({
        default: BusinessPolicyContacts,
      })
    )
  )
);
export const BusinessBasicDetailsRoutes = [
  
 {
            path:`${BUSINESS_POLICY_BASIC_DETAILS}/`,
            exact: true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.BUSINESS_POLICY,
                  MODULE_IDS.BUSINESS_POLICY_ADMIN_MANAGER,
                ]}
              >
                <BusinessPolicyBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path:`${BUSINESS_POLICY_BASIC_DETAILS}/:customerPolicyId`,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.BUSINESS_POLICY,
                  MODULE_IDS.BUSINESS_POLICY_ADMIN_MANAGER,
                ]}
              >
                <BusinessPolicyBasicDetails />
              </AuthorizedRoute>
            ),
          },
          {
            path: "/business-policy/:customerId/contacts/:customerPolicyId",
            exact: true,
            element: (
              <AuthorizedRoute
                moduleKeys={[
                  MODULE_IDS.BUSINESS_POLICY,
                  MODULE_IDS.BUSINESS_POLICY_ADMIN_MANAGER,
                ]}
              >
                <BusinessPolicyContacts />
              </AuthorizedRoute>
            ),
          },
];
